// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../images/Bg Gradient.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23fff%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Heading-nav-ria {
    font-size: 12px;
    font-family: Graphik;
    font-weight: 355;
    color: #FFFFFF;
}

.main-ria {
    position: "relative";
    background-color: rgba(39, 40, 75, 1);
    height: 73vh;
    width: 100%;
    background: transparent;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    margin-top: 60px;
}

.question-section-ria {
    /* border: 1px solid #6B5CD1; */
    margin-top: 0px;
    border-radius: 12px;
}

.equipement-display-bg {
    width: 226px;
    height: 200px;
    margin: 25px 10px 20px 10px;
    border: none;
    border-radius: 5px;
    background: rgba(255, 255, 255, 0.1);

}

.equipement-display-bg-image {
    border: none;
    border-radius: 5px;
    width: 210px;
    height: 180px;
    margin-top: 10px;
    margin-left: 8px;
}

.equipement-display {
    width: 225px;
    height: 140px;
    border: none;
    border-radius: 5px;
    margin: 15px 10px;
}

.overlay-chatbot-ria {
    position: relative;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    margin-top: 0px;
}


.modal-chatbot-container-ria {
    width: 35vw;
    height: 55vh;
    /* margin-left: 20px; */
    /* height:90vh; */
}

.offcanvas-ria {
    height: 50vh;

}

/* .custom-sidebar {
    position: absolute;
    top: 0;
    left: -300px;
    width: 250px;
    height: 100%;
    transition: transform 0.3s ease;
}

.custom-sidebar.open {
    transform: translateX(300px);
    height: 100%;
} */
.custom-sidebar {
    position: absolute;
    top: 0;
    left: -300px;
    width: 250px;
    height: 100%;
    transition: transform 0.3s ease;
    background: linear-gradient(180deg, #303245 0%, #0C1020 100%), linear-gradient(180deg, #424750 0%, #202326 100%);
    border: 1px solid #6B5CD1;
    border-radius: 10px;
}

.custom-sidebar.open {
    border-radius: 10px;
    transform: translateX(300px);
    height: 100%;
    width: 31%;
    background: linear-gradient(180deg, #303245 0%, #0C1020 100%), linear-gradient(180deg, #424750 0%, #202326 100%);
}

.custom-sidebar-close {
    border-radius: 10px;
    height: 58vh;
    width: 6%;
    background: linear-gradient(180deg, #303245 0%, #0C1020 100%), linear-gradient(180deg, #424750 0%, #202326 100%);
    padding-left: 5px;
    border: 1px solid #6B5CD1;
}

.close-button {
    position: absolute;
    top: 10px;
    right: 10px;
}

.toggle-button {
    margin-top: 20px;
}

.bot-ria {
    position: absolute;
    left: 6%;
    top: 8%;
    display: flex;
    height: 90vh;
}

.bot-ria-new {
    position: absolute;
    left: 6%;
    top: 10%;
    display: flex;
    width: 100%;
    height: 60vh;

}

.sidebar-toggle-ria {
    width: 24px;
    margin-left: 17px;
    margin-top: 2px;
}

.sidebar-toggle-ria1 {
    width: 24px;
    margin: 11px 3px;
}

.report-heading-ria {
    font-size: 14px;
    font-family: Graphik;
    font-weight: 450;
    color: #FFFFFF;
    margin: 10px 15px;
}

.inspection-heading-ria {
    font-size: 10px;
    font-family: Graphik;
    font-weight: 400;
    color: #FFFFFF;
    margin: 1px;
}

.parent-report-ria {
    font-size: 13px;
    font-family: Graphik;
    font-weight: 400;
    color: #FFFFFF;
    margin: 10px 25px;
    background-color: #3C4069;
    /* border: none; */
    border-radius: 5px;
    padding: 20px;
    cursor: pointer;
    border: 1px solid rgba(66, 71, 80, 1)
}

.stack-ria-div {
    overflow-y: auto;
    height: 70vh;
}

.stack-question-ria {
    overflow-y: auto;
    height: 55vh;
    scrollbar-width: none;
}
.stack-question-ria:hover {
    scrollbar-width: auto;
}

.stack-ria {
    font-size: 12px;
    font-family: Graphik;
    font-weight: 400;
    color: #FFFFFF;
    margin: 5px;
    background-color: #3C4069;
    border: 1px solid #424750;
    border-radius: 5px;
    padding: 5px;
    line-height: 22px;
    cursor: pointer;
}

.child-report-ria {
    background-color: #1E203D;
}

.childreport-div-ria {
    font-size: 14px;
    font-family: Graphik;
    font-weight: 400;
    color: #FFFFFF;
    margin: 0px 32px;
    position: absolute;
    top: 0;
    left: 4%;
    width: 674px;
    border-radius: 10px;
    height: 58vh;
    background: linear-gradient(180deg, #11121E 0%, #16182E 100%),
        linear-gradient(180deg, #424750 0%, #202326 100%);
    ;
    /* background-color: #1E203D; */
    transition: transform 0.3s ease;
    overflow: auto;
    padding: 0px 5px;
    border: 1px solid #6B5CD1;
    /* margin-top: 200px; */
}

.childreport-div-ria.open {
    left: 27%;
    /* transform: translateX(100px); */
    width: 515px;
}

.DropDown-ria {
    margin-top: 5px;
    width: 80px;
}

.DropDown-ria .dropdown-toggle {
    /* background-color: #3C4069; */
    background-color: transparent;
    color: #FFFFFF;
    border: 1px solid #424750;
    font-size: 14px;
    width: 200px;
    font-weight: 300;
    font-family: Graphik;
}

.DropDown-ria .dropdown-menu {
    background: linear-gradient(180deg, #FFFFFF 0%, #E0E2FF 93.5%);
    font-size: 10px;
    font-weight: 300;
    font-family: Graphik;
    width: 200px;
}

.DropDown-ria .dropdown-item {
    color: black;
    width: 200px;
    height: 25px;
    padding: 5px;
}

.dropdown-dd {
    border-style: solid;
    border-width: 1px;
    border-radius: 5px;
    border-color: #747BA9;
    height: 35px;
    width: 200px;
    background-color: transparent;
    /* margin-left: 5px; */
    margin-top: 10px;
    color: #FFFFFF;
    font-size: 12px;
    font-weight: 400;
    padding-left: 5px;
}

.dropdown-dd::placeholder {
    color: #FFFFFF;
    font-size: 13px;
    padding: 10px 5px;
    font-weight: 300;
    font-family: Graphik;
}

.dropdown-dd:focus {
    outline: none;
}

.dropdown-dd option {
    color: white;
    background-color: rgba(26, 28, 53, 1);
    border: 1px solid #747BA9;
    font-size: 12px;
    font-family: Graphik;
    font-weight: 400;
    margin-top: 10px;
    padding: 8px;
    height: 15px
}

.InputGroup-ria {
    margin-top: 10px;
}

.InputGroup-ria .form-control {
    /* background-color: #1A1C35; */
    background: rgba(26, 28, 53, 1);
    color: #FFFFFF;
    border: 1px solid #747BA9;
    font-size: 13px;
    height: 90px;
}

.InputGroup-ria .form-control::placeholder {
    color: #FFFFFF;
}

.InputGroup-ria-sm {
    margin-top: 10px;
}

.InputGroup-ria-sm .form-control {
    background-color: transparent;
    color: #FFFFFF;
    border: 1px solid #747BA9;
    font-size: 12px;
    height: 35px;
    width: 150px;
}

.InputGroup-ria-sm .form-control::placeholder {
    color: #FFFFFF;
}

.input-text-ria {
    background-color: transparent;
    color: #FFFFFF;
    border: 1px solid #747BA9;
    font-size: 12px;
    height: 35px;
    width: 40px;
}

.send-ria {
    width: 17px;
}

.plus-icon-ria {
    width: 9px;
    margin-right: 3px;
}

.gradient-ria {
    /* background: linear-gradient(0deg, #424750, #202326), linear-gradient(0deg, #303245, #0C1020); */
    /* background-image: linear-gradient(180deg, #303245 0%, #0C1020 100%),
        linear-gradient(180deg, #424750 0%, #202326 100%); */
    border: 1px solid #6B5CD1;
    background: rgba(30, 32, 61, 1);

}


.icon-ria {
    width: 18px;
    margin-left: 70%;
}

.icon-ria-delete {
    width: 15px;
    margin-left: 10px;
}

.stackcol-ria {
    margin-top: 10px;
    border-radius: 12px;
    height: 80vh;
    /* background: linear-gradient(180deg, #303245, #0C1020), linear-gradient(180deg, #424750, #202326); */
    background: transparent;
}

.gradient-ria2 {
    /* background: linear-gradient(180deg, #FFFFFF 0%, #E0E2FF 93.5%);
    opacity: 0.15; */

}

.container-upload-ria {
    border: 1px solid #6B5CD1;
    border-radius: 10px;
    padding-top: 10px;
    margin-top: 10px;
    height: 80vh;
    width: 70vw;
    background: rgba(255, 255, 255, 0.1);
}

.browse-files-containers-ria {
    border: 1px solid grey;
    background-color: transparent;
    margin-right: 25px;
    color: white;
    text-align: center;
    height: 135px;
    width: 45%;
    border-radius: 10px;
}

.right-sub-container-ria {
    border: 1px solid rgba(0, 0, 0, 0.1);
    border-radius: 10px;
    padding-top: 10px;
    justify-content: center;
    text-align: center;
    color: #1D203C;
    font-family: 'Graphik', sans-serif;
    /* background-color: rgba(0, 0, 0, 0.1); */
    background: linear-gradient(180deg, #11121E 0%, #16182E 100%), linear-gradient(180deg, #424750 0%, #202326 100%);
    margin-top: 8%;
}

.right-sub-container-ria-diplay {
    height: 230px;
    width: 80%;
    margin-left: 10%;
}

.right-metadata-container-ria-diplay {
    margin-left: 10%;
    height: 230px;
    width: 100%;
}

/* .upload-ria-button {
    margin-top: 5%;
    margin-left: 45%;
    background-color: #6B5CD1;
    border-radius: 10px;
    border: none;
} */

/* .process-ria-button {
    margin-top: 40%;
    margin-left: 43%;
    background-color: #6B5CD1;
    border-radius: 10px;
    border: none;
} */
.process-ria-button {
    margin-top: 45%;
    margin-left: 45%;
    background: linear-gradient(131.99deg, #0AAAE0 6.23%, rgba(10, 170, 224, 0.5) 85.46%);
    border-radius: 50px;
    color: #FFFFFF;
    font-size: 13px;
    font-weight: 400;
    border: none;
}

.metadata-ria {
    position: absolute;
    display: flex;
    border: 1px solid;
    /* background: rgba(255, 255, 255, 0.1); */
    /* border: 1px solid #6B5CD1; */

    border-image-source: linear-gradient(180deg, #424750 0%, #202326 100%);
    /* background: rgba(42, 45, 78, 1); */
    /* background: linear-gradient(180deg, #11121E 0%, #16182E 100%),
        linear-gradient(180deg, #424750 0%, #202326 100%); */
    background: linear-gradient(180deg, #11121E 0%, #16182E 100%), linear-gradient(180deg, #424750 0%, #202326 100%);
    top: 2%;
    border-radius: 10px;
    width: 97%;
    left: 3%;
    padding-bottom: 10px;
}

.metdata-container-ria {
    position: absolute;
    /* background: rgba(60, 64, 105, 1); */
    background: rgba(255, 255, 255, 0.1);
    /* background: linear-gradient(180deg, #FFFFFF 0%, #E0E2FF 93.5%); */
    top: 3%;
    border-radius: 10px;
    height: 80vh;
    width: 70vw;
    overflow-y: auto;
    border: 1px solid #6B5CD1;
}

.metdata-accordian-ria {
    position: absolute;
    margin-top: 33%;
    border-radius: 10px;
    width: 97%;
    background-color: rgba(60, 64, 105, 1);
    border: none;
    color: white
}

.metdata-accordian-ria .accordion-body {
    background-color: #1E203D;
    color: white;
    overflow-y: scroll;
    max-height: 360px;
    border: none;
}

.accordion-item {
    border: none;
}

.accordion-button.collapsed {
    background: blue
}

.panel-heading a:not(.collapsed) {
    border-bottom: 1px solid red;
}

.accordion-button.collapsed::after {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

/* .accordion-button.collapsed::before {
    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e");
  } */

.accordion-button:not(.collapsed)::after {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.priority-ria {
    background: linear-gradient(96.44deg, #8E2DE2 10.7%, #6A19D8 89.51%);
    border: none;
    font-size: 10px;
    font-weight: 400;
    font-family: Graphik;
    border-radius: 20px;
    height: 25px;
    margin-left: 10px;
    margin-bottom: 10px;
}

.image-ria-bg {
    background: rgba(0, 0, 0, 0.1);
    border-radius: 10px;
}

.browse-text-ria {
    margin-top: 5px;
    text-align: center;
}

/* .upload-file-button-ria {
    font-size: 10px;
    font-size: 14px;
    font-family: Graphik;
    width: 70%;
    height: 35px;
    margin-top: 25px;
    margin-left: 20px;
    margin-right: 20px;
    color: #fff;
    border-radius: 50px;
    background-color: #6B5CD1;
    cursor: pointer;
} */

.final-stack-ria {
    position: relative;
}

.upload-ria {
    position: absolute;
    width: 20px;
    top: 5%;
    left: 93%;
    cursor: pointer;
}

/* .resizable {
    border: 1px solid #ccc;
    padding: 10px;
    overflow: hidden; 
    resize: both; 
  }
  .left-sub-container-ref {  
    min-width: 25%;
    color: #FFFFFF;
    font-family: 'Graphik', sans-serif;
    margin-right: 10px;
    padding: 10px;
    text-align: center;
    align-self: normal;
    border: 1px solid rgba(255, 255, 255, 0.3);
    border-radius: 10px;
    resize: horizontal;
    cursor: ew-resize;
    background: linear-gradient(180deg, #303245 0%, #0C1020 100%);


    
  }
  .right-sub-container-ref {
    flex-grow: 1;
    border: 1px solid rgba(0, 0, 0, 0.1);
    border-radius: 10px;
    padding-top: 10px;
    justify-content: center;
    text-align: center;
    height: 230px;
    max-width: 70%;
    color: #1D203C;
    font-family: 'Graphik', sans-serif;
    resize: both;
    margin-left: 10px;
    background:  linear-gradient(to bottom,rgba(255, 255, 255, 0.15),rgba(224, 226, 255, 1)); 

  } */
.ria-file-upload {
    display: inline-block;
    position: relative;
    font-family: Arial, sans-serif;
    /* overflow: hidden; */
    margin-right: 5px;
    margin-top: 5px;
    /* margin-left: 78%; */
    padding-bottom: 5px;
}

.ria-file-upload input[type="file"] {
    font-size: 0px;
    position: absolute;
    left: 0;
    top: 0;
    opacity: 0;
}

.ria-file-upload-span {
    padding: 5px 6px 8px 0px;
    cursor: pointer;
    border-radius: 5px;
    border: 1px solid rgba(116, 123, 169, 1);
    color: rgba(255, 255, 255, 1);
}

.ria-file-upload-span:hover {
    background: rgba(116, 123, 169, 1);
}

.ria-file-upload-load {
    padding: 6px 6px 5px 6px;
    border-radius: 5px;
    border: 1px solid rgba(116, 123, 169, 1);
    color: rgba(255, 255, 255, 1);
    /* width:100px; */
    /* height:20px; */
    /* margin-left: 60px; */
    /* background-color: rgba(116, 123, 169, 0.3); */
}

.position-nav-ria {}



.modal-overlay-ria {
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 1000;
    top: 0;
    left: 0;
}

.modal-ria {
    background-color: rgba(30, 32, 61, 1);
    border: 1px solid #6B5CD1;
    border-radius: 8px;
}

.modal-content-ria {
    /* display: flex; */
    margin-left: 5px;
    /* flex-direction: row; */
    margin-right: 10px;
    padding: 20px 0px;
}

.close-icon-ria {
    font-size: 24px;
    position: absolute;
    cursor: pointer;
    color: blueviolet;
    background-color: transparent;
    border: none;
    border-radius: 5px;
    width: 23px;
    float: left;
    margin-left: 170px;
}

.final-button-ria {
    border: 1px solid #6A59FF;
    border-radius: 10px;
    background-color: transparent;
    font-size: 13px;
    font-family: Graphik;
    color: #FFFFFF;
    font-weight: 300;
    padding: 5px 10px;
    margin: 0px 10px 20px 12px;
    width: 13vw;
    max-height: 5vh;
}

.final-button-ria:hover {
    background-color: linear-gradient(131.99deg, #0AAAE0 6.23%, #0AAAE0 85.46%);

}

.nav-button-ria:hover {
    background: linear-gradient(131.99deg, #0AAAE0 6.23%, #0AAAE0 85.46%);
    /* background-color:  #0AAAE0; */
    color: #FFFFFF;
    /* color: black; */
}

.shade-ria {
    display: flex;
    flex-direction: row;
    /* background-color: #6a59ff28; */
    width: 30vw;
    height: 10vh;
}

.key-table-ria {
    color: white !important;
    font-size: 12px !important;
    font-family: Graphik !important;
    font-weight: 400 !important;
    margin-top: 5px !important;
    line-height: 35px !important;
}

.para-first-ref {
    color: #FFFFFF;
    background-color: transparent;
    text-align: center;
    font-weight: 400;
    margin-top: 10px;
}

.loader-screen-ref {
    background: transparent;
    padding: 35px;
    min-width: 100%;
    border: 1px solid #6B5CD1;
    border-radius: 10px;
    margin: 10px;
    height: 80vh;
    width: 70vw;
}

.loader-ref {
    margin-top: 85px;
    margin-left: 32vw;
}


.loader-ref-sidebar {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 40px;
    margin-top: 90px;
    margin-right: 90px;
    margin-left: 60px;
}

.loader-ref-modal {
    margin-top: 20px;
    margin-left: 12vw;
    width: 22vw;
    height: 1px;
}

.para-first-ref2 {
    color: #FFFFFF;
    background-color: transparent;
    text-align: center;
    font-weight: 400;
    margin-top: 10px;
}

.loader-screen-ref2 {
    background: transparent;
    padding: 35px;
    min-width: 91vw;
    border: 1px solid #6B5CD1;
    border-radius: 10px;
    /* margin-top: 20px; */
    margin-left: 15px;
    margin-right: 30px;
    height: 76vh
}

.loader-ref2 {
    margin-top: 80px;
    margin-left: 47%;
}

.table-ria {
    color: white;
    font-size: 12px;
    font-family: Graphik;
    font-weight: 400;
    margin-top: 10px;
    margin-left: 6px;
    line-height: 35px;
    margin-bottom: 10px;
}

.chatbot-img-full-ria {
    width: 100%;
    border-radius: 5px;
    height: 100%;
    padding: 7px;
    border: 1px solid #FFFFFF;
    /* margin: 30px 60px; */
}

.modal-ria-img {
    background-color: rgba(30, 32, 61, 1);
    border: 1px solid #6B5CD1;
    border-radius: 8px;
    overflow-y: auto;
    height: 60%;
    width: 50%;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
}

.image-choosen {
    width: 150px;
    margin: 15px 10px;
    border: none;
    border-radius: 10px;
}

.gallery-text {
    font-family: Graphik;
    font-size: 13px;
    font-weight: 400;
    color: white;
    margin: 10px;
}

.accordian-test-ria {
    font-family: Graphik;
    font-size: 12px;
    color: black;
}

/* 
.accordion-button {
    width: 100%;
    background-color: white;
    max-height: 40px;
    color: black;
  } */
.accordion-button:not(.collapsed) {
    background-color: rgba(21, 23, 43, 1);
    color: #FFFFFF;
    font-family: Graphik;
    font-size: 14px;
}

.accordion-button.collapsed {
    background-color: rgba(21, 23, 43, 1);
    color: #FFFFFF;
    font-family: Graphik;
    font-size: 14px;
}



.item-equip-ria {
    margin-bottom: auto;
    text-align: left;
    font-size: 12.5px;
    margin-left: 10px;
    font-weight: 500;
}

.item-timestamp-ria {
    margin-bottom: auto;
    font-size: 12px;
    font-weight: 400;
    margin-left: 10px;
    margin-top: 5px;
}

.upload-image {
    font-size: 16px;
    font-weight: 500;
    text-align: center;
    margin-bottom: 15px;
}

.key-table-ria {
    color: white;
}

.uploaded-num-ria {
    margin-left: 450px;
    font-weight: 300;
    font-size: 12px;
}

.add-info-ria {
    font-size: 15px;
    font-weight: 500;
}

.nav-button-ria {
    background: transparent;
    border: 1px solid #0AAAE0;
    /* border-image-source: linear-gradient(180deg, #0AAAE0 0%, #0AAAE0 100%); */
    width: 100px;
    border-radius: 50px;
    color: #0AAAE0;
    margin-left: 5px;
    font-size: 14px;
    font-family: Graphik;
    font-weight: 400;
    padding: 3px;
}

/* .nav-button-ria {
    border: 1px solid #6A59FF;
    border-radius: 10px;
    background-color: transparent;
    font-size: 13px;
    font-family: Graphik;
    color: #FFFFFF;
    font-weight: 300;
    padding: 5px 15px;
    margin-left: 40px;
} */


.arrow-pic-ria {
    width: 10px;
    margin-top: -2px;
    margin-left: 2px;
    margin-right: 2px;
    /* color:#0AAAE0; */
}

.nav-button-container1-ria {
    text-align: right;
}

.upload-file-button-ria {
    font-size: 10px;
    font-size: 14px;
    font-family: Graphik;
    width: 70%;
    height: 35px;
    margin-top: 25px;
    margin-left: 20px;
    margin-right: 20px;
    color: #fff;
    border: 2px solid #297FAE;
    /* border: 1px solid;
    border-image-source: linear-gradient(180deg, #0EA3D7 0%, #297FAE 100%); */
    border-radius: 50px;
    /* background-color: #6B5CD1; */
    cursor: pointer;
}

.upload-ria-button {
    margin-top: 5%;
    margin-left: 42%;
    /* background-color: #6B5CD1; */
    background: linear-gradient(131.99deg, #0AAAE0 6.23%, rgba(10, 170, 224, 0.5) 85.46%);
    border-radius: 50px;
    border: none;
    color: #FFFFFF;
    font-size: 13px;
    font-weight: 400;
    width: 150px;
    height: 30px;
}

.regenerate-ria {
    width: 23px;
    margin-left: 10px;
    /* margin-bottom: 3px; */
    cursor: pointer;
    border: 1px solid #6A19D8;
    padding: 2px;
    border-radius: 5px;
    margin-bottom: 10px;
}

.row1-ria {
    background: linear-gradient(180deg, #11121E 0%, #16182E 100%), linear-gradient(180deg, #424750 0%, #202326 100%);
    /* margin-left: -10px; */
    width: 106%;
    border-radius: 10px;
    --bs-gutter-x: 1.5rem;
    --bs-gutter-y: 0;
    display: flex;
    flex-wrap: wrap;
    margin-top: calc(-1 * var(--bs-gutter-y));
    margin-right: calc(-0.5 * var(--bs-gutter-x));
    margin-left: calc(-0.5 * var(--bs-gutter-x));
    border: 1px solid #6A19D8;
}

.row1-ria1 {
    width: 100%;
    border-radius: 10px;
    --bs-gutter-x: 1.5rem;
    --bs-gutter-y: 0;
    display: flex;
    flex-wrap: wrap;
    margin-top: calc(-1 * var(--bs-gutter-y));
    margin-right: calc(-0.5 * var(--bs-gutter-x));
    margin-left: calc(-0.5 * var(--bs-gutter-x));
}

.top-part-chart-chatbot-ria {
    height: 40px;
    width: 100%;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    display: flex;
    flex-direction: row;
    border-bottom: 1px solid #6B5CD1;
    /* background-color: rgb(54, 54, 89); */
    padding: 5px;
    color: white;
    font-size: 13px;
    font-weight: 500;
    /* background: linear-gradient(180deg, #11121E 0%, #16182E 100%),
linear-gradient(180deg, #424750 0%, #202326 100%); */
    background: rgba(26, 28, 53, 1);

}

.bottom-part-chart-chatbot-ria {
    margin-top: 10px;
    display: flex;
    width: 100%;
    background: rgba(26, 28, 53, 1);
    /* background-color: rgb(54, 54, 89); */
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
    border: 1px solid #6B5CD1;
}

.left-section-chat-chatbot-ria {
    /* background: linear-gradient(180deg, #303245 0%, #0C1020 100%), linear-gradient(180deg, #424750 0%, #202326 100%); */
    background-color: #1E203D;
    /* background: linear-gradient(0deg, #2A2D4E, #2A2D4E),
    linear-gradient(0deg, #747BA9, #747BA9); */
    /* background: linear-gradient(180deg, #FFFFFF 0%, #E0E2FF 93.5%); */

    border: 1px solid #6B5CD1;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    /* height: 85vh; */
    /* width: 37vw; */
}

.bg-bot-chatbot-ria {
    /* background-color: rgba(45, 50, 90, 1); */
    border-radius: 0px 10px 10px 10px;
    background: linear-gradient(180deg, #11121E 0%, #16182E 100%),
        linear-gradient(180deg, #424750 0%, #202326 100%);
}


.chat-input-chart-chatbot-ria ::placeholder {
    color: white;
    font-family: Graphik;
    font-size: 14px;
    font-weight: 350;
}

.chat-input-chart-chatbot-ria:focus {
    border: 1px solid black;
}

.chat-input-chart-chatbot-ria {
    margin-left: 3%;
    margin-right: 10px;
    /* margin-top: 10px; */
    padding: 2px;
    width: 90%;
    font-family: 'Graphik', sans-serif;
    color: white;
    font-size: 14px;
    height: 15%;
    background: rgba(26, 28, 53, 1);
    /* background: linear-gradient(180deg, #11121E 0%, #16182E 100%),
    linear-gradient(180deg, #424750 0%, #202326 100%);; */
}

.bg-user-chatbot-ria {
    background-color: rgba(26, 28, 53, 1);
    border-radius: 0px 10px 10px 10px;
    border-style: icon solid;
    min-width: 50px;
    margin-left: 40px;
}




::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    border-radius: 10px;
    background-color: transparent;
    width: 2px;
}

::-webkit-scrollbar {
    width: 4px;
    height: 4px;
    background-color: transparent;
}


::-webkit-scrollbar-thumb {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, .3);
    background-color: #F5F5F5;
}


.InputGroup-ria1 .form-control {
    background-color: #1A1C35;
    color: #FFFFFF;
    border: 1px solid #747BA9;
    font-size: 12px;
    height: 90px;
}

.text-chart-chatbot-ria {
    margin-top: 5px;
    color: white;
    /* background-color: rgba(37, 40, 67, 1); */
    font-size: 12px;
    font-weight: 400;
    margin-right: 5px;
    font-family: Graphik;
    padding-left: 7px;
    height: 80px;
    width: 100%;
    border-radius: 10px;
    border: 1px solid #6B5CD1;
    background-color: #1A1C35;
    text-align: left;
}

.chat-messages-c-chatbot-ria {
    height: 63vh;
    color: white;
    font-size: 10px;
    overflow-y: scroll;
}

.analysis-head2-file-ria {
    color: #FFFFFF;
    font-size: 13px;
    font-family: Graphik;
    font-weight: 450;
    margin-top: 10px;
}`, "",{"version":3,"sources":["webpack://./src/Refinery_Inspection_Bot/Refinery.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,oBAAoB;IACpB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,oBAAoB;IACpB,qCAAqC;IACrC,YAAY;IACZ,WAAW;IACX,uBAAuB;IACvB,yDAAmD;IACnD,sBAAsB;IACtB,2BAA2B;IAC3B,4BAA4B;IAC5B,gBAAgB;AACpB;;AAEA;IACI,+BAA+B;IAC/B,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,2BAA2B;IAC3B,YAAY;IACZ,kBAAkB;IAClB,oCAAoC;;AAExC;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,eAAe;AACnB;;;AAGA;IACI,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB,iBAAiB;AACrB;;AAEA;IACI,YAAY;;AAEhB;;AAEA;;;;;;;;;;;;GAYG;AACH;IACI,kBAAkB;IAClB,MAAM;IACN,YAAY;IACZ,YAAY;IACZ,YAAY;IACZ,+BAA+B;IAC/B,gHAAgH;IAChH,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,4BAA4B;IAC5B,YAAY;IACZ,UAAU;IACV,gHAAgH;AACpH;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,SAAS;IACT,gHAAgH;IAChH,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;AACf;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,OAAO;IACP,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,QAAQ;IACR,aAAa;IACb,WAAW;IACX,YAAY;;AAEhB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,oBAAoB;IACpB,gBAAgB;IAChB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,oBAAoB;IACpB,gBAAgB;IAChB,cAAc;IACd,WAAW;AACf;;AAEA;IACI,eAAe;IACf,oBAAoB;IACpB,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,aAAa;IACb,eAAe;IACf;AACJ;;AAEA;IACI,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,qBAAqB;AACzB;AACA;IACI,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,oBAAoB;IACpB,gBAAgB;IAChB,cAAc;IACd,WAAW;IACX,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,oBAAoB;IACpB,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,YAAY;IACZ,mBAAmB;IACnB,YAAY;IACZ;yDACqD;;IAErD,+BAA+B;IAC/B,+BAA+B;IAC/B,cAAc;IACd,gBAAgB;IAChB,yBAAyB;IACzB,uBAAuB;AAC3B;;AAEA;IACI,SAAS;IACT,kCAAkC;IAClC,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,WAAW;AACf;;AAEA;IACI,+BAA+B;IAC/B,6BAA6B;IAC7B,cAAc;IACd,yBAAyB;IACzB,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,8DAA8D;IAC9D,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,qBAAqB;IACrB,YAAY;IACZ,YAAY;IACZ,6BAA6B;IAC7B,sBAAsB;IACtB,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,qCAAqC;IACrC,yBAAyB;IACzB,eAAe;IACf,oBAAoB;IACpB,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;IACZ;AACJ;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,+BAA+B;IAC/B,+BAA+B;IAC/B,cAAc;IACd,yBAAyB;IACzB,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,6BAA6B;IAC7B,cAAc;IACd,yBAAyB;IACzB,eAAe;IACf,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,6BAA6B;IAC7B,cAAc;IACd,yBAAyB;IACzB,eAAe;IACf,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,UAAU;IACV,iBAAiB;AACrB;;AAEA;IACI,kGAAkG;IAClG;4DACwD;IACxD,yBAAyB;IACzB,+BAA+B;;AAEnC;;;AAGA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;IACZ,sGAAsG;IACtG,uBAAuB;AAC3B;;AAEA;IACI;oBACgB;;AAEpB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;IACZ,WAAW;IACX,oCAAoC;AACxC;;AAEA;IACI,sBAAsB;IACtB,6BAA6B;IAC7B,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,oCAAoC;IACpC,mBAAmB;IACnB,iBAAiB;IACjB,uBAAuB;IACvB,kBAAkB;IAClB,cAAc;IACd,kCAAkC;IAClC,0CAA0C;IAC1C,gHAAgH;IAChH,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,WAAW;AACf;;AAEA;;;;;;GAMG;;AAEH;;;;;;GAMG;AACH;IACI,eAAe;IACf,gBAAgB;IAChB,qFAAqF;IACrF,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,iBAAiB;IACjB,0CAA0C;IAC1C,+BAA+B;;IAE/B,sEAAsE;IACtE,qCAAqC;IACrC;4DACwD;IACxD,gHAAgH;IAChH,OAAO;IACP,mBAAmB;IACnB,UAAU;IACV,QAAQ;IACR,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,sCAAsC;IACtC,oCAAoC;IACpC,oEAAoE;IACpE,OAAO;IACP,mBAAmB;IACnB,YAAY;IACZ,WAAW;IACX,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,UAAU;IACV,sCAAsC;IACtC,YAAY;IACZ;AACJ;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI;AACJ;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,yDAA8R;AAClS;;AAEA;;KAEK;;AAEL;IACI,yDAA8R;AAClS;;AAEA;IACI,oEAAoE;IACpE,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;;;;;;;;;;;;;GAaG;;AAEH;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,OAAO;IACP,SAAS;IACT,eAAe;AACnB;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;KAsCK;AACL;IACI,qBAAqB;IACrB,kBAAkB;IAClB,8BAA8B;IAC9B,sBAAsB;IACtB,iBAAiB;IACjB,eAAe;IACf,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,UAAU;AACd;;AAEA;IACI,wBAAwB;IACxB,eAAe;IACf,kBAAkB;IAClB,wCAAwC;IACxC,6BAA6B;AACjC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,wBAAwB;IACxB,kBAAkB;IAClB,wCAAwC;IACxC,6BAA6B;IAC7B,iBAAiB;IACjB,iBAAiB;IACjB,uBAAuB;IACvB,gDAAgD;AACpD;;AAEA,mBAAmB;;;;AAInB;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,aAAa;IACb,MAAM;IACN,OAAO;AACX;;AAEA;IACI,qCAAqC;IACrC,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,6BAA6B;IAC7B,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,6BAA6B;IAC7B,eAAe;IACf,oBAAoB;IACpB,cAAc;IACd,gBAAgB;IAChB,iBAAiB;IACjB,0BAA0B;IAC1B,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,2EAA2E;;AAE/E;;AAEA;IACI,qEAAqE;IACrE,gCAAgC;IAChC,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,iCAAiC;IACjC,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,uBAAuB;IACvB,0BAA0B;IAC1B,+BAA+B;IAC/B,2BAA2B;IAC3B,0BAA0B;IAC1B,4BAA4B;AAChC;;AAEA;IACI,cAAc;IACd,6BAA6B;IAC7B,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;IACvB,aAAa;IACb,eAAe;IACf,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;;;AAGA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,WAAW;IACX,WAAW;AACf;;AAEA;IACI,cAAc;IACd,6BAA6B;IAC7B,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;IACvB,aAAa;IACb,eAAe;IACf,yBAAyB;IACzB,mBAAmB;IACnB,sBAAsB;IACtB,iBAAiB;IACjB,kBAAkB;IAClB;AACJ;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,oBAAoB;IACpB,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,yBAAyB;IACzB,uBAAuB;AAC3B;;AAEA;IACI,qCAAqC;IACrC,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,UAAU;IACV,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,oBAAoB;IACpB,eAAe;IACf,YAAY;AAChB;;AAEA;;;;;;KAMK;AACL;IACI,qCAAqC;IACrC,cAAc;IACd,oBAAoB;IACpB,eAAe;AACnB;;AAEA;IACI,qCAAqC;IACrC,cAAc;IACd,oBAAoB;IACpB,eAAe;AACnB;;;;AAIA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;IACvB,yBAAyB;IACzB,4EAA4E;IAC5E,YAAY;IACZ,mBAAmB;IACnB,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,oBAAoB;IACpB,gBAAgB;IAChB,YAAY;AAChB;;AAEA;;;;;;;;;;GAUG;;;AAGH;IACI,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,eAAe;IACf,oBAAoB;IACpB,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;IACX,yBAAyB;IACzB;6EACyE;IACzE,mBAAmB;IACnB,+BAA+B;IAC/B,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,+BAA+B;IAC/B,qFAAqF;IACrF,mBAAmB;IACnB,YAAY;IACZ,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,wBAAwB;IACxB,eAAe;IACf,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,gHAAgH;IAChH,wBAAwB;IACxB,WAAW;IACX,mBAAmB;IACnB,qBAAqB;IACrB,gBAAgB;IAChB,aAAa;IACb,eAAe;IACf,yCAAyC;IACzC,6CAA6C;IAC7C,4CAA4C;IAC5C,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,qBAAqB;IACrB,gBAAgB;IAChB,aAAa;IACb,eAAe;IACf,yCAAyC;IACzC,6CAA6C;IAC7C,4CAA4C;AAChD;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,4BAA4B;IAC5B,6BAA6B;IAC7B,aAAa;IACb,mBAAmB;IACnB,gCAAgC;IAChC,uCAAuC;IACvC,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB;oDACgD;IAChD,+BAA+B;;AAEnC;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,WAAW;IACX,+BAA+B;IAC/B,uCAAuC;IACvC,+BAA+B;IAC/B,gCAAgC;IAChC,yBAAyB;AAC7B;;AAEA;IACI,sHAAsH;IACtH,yBAAyB;IACzB;8CAC0C;IAC1C,oEAAoE;;IAEpE,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,2CAA2C;IAC3C,iCAAiC;IACjC;yDACqD;AACzD;;;AAGA;IACI,YAAY;IACZ,oBAAoB;IACpB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,sBAAsB;IACtB,YAAY;IACZ,UAAU;IACV,kCAAkC;IAClC,YAAY;IACZ,eAAe;IACf,WAAW;IACX,+BAA+B;IAC/B;yDACqD;AACzD;;AAEA;IACI,qCAAqC;IACrC,iCAAiC;IACjC,wBAAwB;IACxB,eAAe;IACf,iBAAiB;AACrB;;;;;AAKA;IACI,oDAAoD;IACpD,mBAAmB;IACnB,6BAA6B;IAC7B,UAAU;AACd;;AAEA;IACI,UAAU;IACV,WAAW;IACX,6BAA6B;AACjC;;;AAGA;IACI,mBAAmB;IACnB,mDAAmD;IACnD,yBAAyB;AAC7B;;;AAGA;IACI,yBAAyB;IACzB,cAAc;IACd,yBAAyB;IACzB,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,2CAA2C;IAC3C,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;IACpB,iBAAiB;IACjB,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,yBAAyB;IACzB,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,oBAAoB;IACpB,gBAAgB;IAChB,gBAAgB;AACpB","sourcesContent":[".Heading-nav-ria {\n    font-size: 12px;\n    font-family: Graphik;\n    font-weight: 355;\n    color: #FFFFFF;\n}\n\n.main-ria {\n    position: \"relative\";\n    background-color: rgba(39, 40, 75, 1);\n    height: 73vh;\n    width: 100%;\n    background: transparent;\n    background-image: url(\"../images/Bg\\ Gradient.svg\");\n    background-size: cover;\n    background-position: center;\n    background-repeat: no-repeat;\n    margin-top: 60px;\n}\n\n.question-section-ria {\n    /* border: 1px solid #6B5CD1; */\n    margin-top: 0px;\n    border-radius: 12px;\n}\n\n.equipement-display-bg {\n    width: 226px;\n    height: 200px;\n    margin: 25px 10px 20px 10px;\n    border: none;\n    border-radius: 5px;\n    background: rgba(255, 255, 255, 0.1);\n\n}\n\n.equipement-display-bg-image {\n    border: none;\n    border-radius: 5px;\n    width: 210px;\n    height: 180px;\n    margin-top: 10px;\n    margin-left: 8px;\n}\n\n.equipement-display {\n    width: 225px;\n    height: 140px;\n    border: none;\n    border-radius: 5px;\n    margin: 15px 10px;\n}\n\n.overlay-chatbot-ria {\n    position: relative;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    height: 100%;\n    margin-top: 0px;\n}\n\n\n.modal-chatbot-container-ria {\n    width: 35vw;\n    height: 55vh;\n    /* margin-left: 20px; */\n    /* height:90vh; */\n}\n\n.offcanvas-ria {\n    height: 50vh;\n\n}\n\n/* .custom-sidebar {\n    position: absolute;\n    top: 0;\n    left: -300px;\n    width: 250px;\n    height: 100%;\n    transition: transform 0.3s ease;\n}\n\n.custom-sidebar.open {\n    transform: translateX(300px);\n    height: 100%;\n} */\n.custom-sidebar {\n    position: absolute;\n    top: 0;\n    left: -300px;\n    width: 250px;\n    height: 100%;\n    transition: transform 0.3s ease;\n    background: linear-gradient(180deg, #303245 0%, #0C1020 100%), linear-gradient(180deg, #424750 0%, #202326 100%);\n    border: 1px solid #6B5CD1;\n    border-radius: 10px;\n}\n\n.custom-sidebar.open {\n    border-radius: 10px;\n    transform: translateX(300px);\n    height: 100%;\n    width: 31%;\n    background: linear-gradient(180deg, #303245 0%, #0C1020 100%), linear-gradient(180deg, #424750 0%, #202326 100%);\n}\n\n.custom-sidebar-close {\n    border-radius: 10px;\n    height: 58vh;\n    width: 6%;\n    background: linear-gradient(180deg, #303245 0%, #0C1020 100%), linear-gradient(180deg, #424750 0%, #202326 100%);\n    padding-left: 5px;\n    border: 1px solid #6B5CD1;\n}\n\n.close-button {\n    position: absolute;\n    top: 10px;\n    right: 10px;\n}\n\n.toggle-button {\n    margin-top: 20px;\n}\n\n.bot-ria {\n    position: absolute;\n    left: 6%;\n    top: 8%;\n    display: flex;\n    height: 90vh;\n}\n\n.bot-ria-new {\n    position: absolute;\n    left: 6%;\n    top: 10%;\n    display: flex;\n    width: 100%;\n    height: 60vh;\n\n}\n\n.sidebar-toggle-ria {\n    width: 24px;\n    margin-left: 17px;\n    margin-top: 2px;\n}\n\n.sidebar-toggle-ria1 {\n    width: 24px;\n    margin: 11px 3px;\n}\n\n.report-heading-ria {\n    font-size: 14px;\n    font-family: Graphik;\n    font-weight: 450;\n    color: #FFFFFF;\n    margin: 10px 15px;\n}\n\n.inspection-heading-ria {\n    font-size: 10px;\n    font-family: Graphik;\n    font-weight: 400;\n    color: #FFFFFF;\n    margin: 1px;\n}\n\n.parent-report-ria {\n    font-size: 13px;\n    font-family: Graphik;\n    font-weight: 400;\n    color: #FFFFFF;\n    margin: 10px 25px;\n    background-color: #3C4069;\n    /* border: none; */\n    border-radius: 5px;\n    padding: 20px;\n    cursor: pointer;\n    border: 1px solid rgba(66, 71, 80, 1)\n}\n\n.stack-ria-div {\n    overflow-y: auto;\n    height: 70vh;\n}\n\n.stack-question-ria {\n    overflow-y: auto;\n    height: 55vh;\n    scrollbar-width: none;\n}\n.stack-question-ria:hover {\n    scrollbar-width: auto;\n}\n\n.stack-ria {\n    font-size: 12px;\n    font-family: Graphik;\n    font-weight: 400;\n    color: #FFFFFF;\n    margin: 5px;\n    background-color: #3C4069;\n    border: 1px solid #424750;\n    border-radius: 5px;\n    padding: 5px;\n    line-height: 22px;\n    cursor: pointer;\n}\n\n.child-report-ria {\n    background-color: #1E203D;\n}\n\n.childreport-div-ria {\n    font-size: 14px;\n    font-family: Graphik;\n    font-weight: 400;\n    color: #FFFFFF;\n    margin: 0px 32px;\n    position: absolute;\n    top: 0;\n    left: 4%;\n    width: 674px;\n    border-radius: 10px;\n    height: 58vh;\n    background: linear-gradient(180deg, #11121E 0%, #16182E 100%),\n        linear-gradient(180deg, #424750 0%, #202326 100%);\n    ;\n    /* background-color: #1E203D; */\n    transition: transform 0.3s ease;\n    overflow: auto;\n    padding: 0px 5px;\n    border: 1px solid #6B5CD1;\n    /* margin-top: 200px; */\n}\n\n.childreport-div-ria.open {\n    left: 27%;\n    /* transform: translateX(100px); */\n    width: 515px;\n}\n\n.DropDown-ria {\n    margin-top: 5px;\n    width: 80px;\n}\n\n.DropDown-ria .dropdown-toggle {\n    /* background-color: #3C4069; */\n    background-color: transparent;\n    color: #FFFFFF;\n    border: 1px solid #424750;\n    font-size: 14px;\n    width: 200px;\n    font-weight: 300;\n    font-family: Graphik;\n}\n\n.DropDown-ria .dropdown-menu {\n    background: linear-gradient(180deg, #FFFFFF 0%, #E0E2FF 93.5%);\n    font-size: 10px;\n    font-weight: 300;\n    font-family: Graphik;\n    width: 200px;\n}\n\n.DropDown-ria .dropdown-item {\n    color: black;\n    width: 200px;\n    height: 25px;\n    padding: 5px;\n}\n\n.dropdown-dd {\n    border-style: solid;\n    border-width: 1px;\n    border-radius: 5px;\n    border-color: #747BA9;\n    height: 35px;\n    width: 200px;\n    background-color: transparent;\n    /* margin-left: 5px; */\n    margin-top: 10px;\n    color: #FFFFFF;\n    font-size: 12px;\n    font-weight: 400;\n    padding-left: 5px;\n}\n\n.dropdown-dd::placeholder {\n    color: #FFFFFF;\n    font-size: 13px;\n    padding: 10px 5px;\n    font-weight: 300;\n    font-family: Graphik;\n}\n\n.dropdown-dd:focus {\n    outline: none;\n}\n\n.dropdown-dd option {\n    color: white;\n    background-color: rgba(26, 28, 53, 1);\n    border: 1px solid #747BA9;\n    font-size: 12px;\n    font-family: Graphik;\n    font-weight: 400;\n    margin-top: 10px;\n    padding: 8px;\n    height: 15px\n}\n\n.InputGroup-ria {\n    margin-top: 10px;\n}\n\n.InputGroup-ria .form-control {\n    /* background-color: #1A1C35; */\n    background: rgba(26, 28, 53, 1);\n    color: #FFFFFF;\n    border: 1px solid #747BA9;\n    font-size: 13px;\n    height: 90px;\n}\n\n.InputGroup-ria .form-control::placeholder {\n    color: #FFFFFF;\n}\n\n.InputGroup-ria-sm {\n    margin-top: 10px;\n}\n\n.InputGroup-ria-sm .form-control {\n    background-color: transparent;\n    color: #FFFFFF;\n    border: 1px solid #747BA9;\n    font-size: 12px;\n    height: 35px;\n    width: 150px;\n}\n\n.InputGroup-ria-sm .form-control::placeholder {\n    color: #FFFFFF;\n}\n\n.input-text-ria {\n    background-color: transparent;\n    color: #FFFFFF;\n    border: 1px solid #747BA9;\n    font-size: 12px;\n    height: 35px;\n    width: 40px;\n}\n\n.send-ria {\n    width: 17px;\n}\n\n.plus-icon-ria {\n    width: 9px;\n    margin-right: 3px;\n}\n\n.gradient-ria {\n    /* background: linear-gradient(0deg, #424750, #202326), linear-gradient(0deg, #303245, #0C1020); */\n    /* background-image: linear-gradient(180deg, #303245 0%, #0C1020 100%),\n        linear-gradient(180deg, #424750 0%, #202326 100%); */\n    border: 1px solid #6B5CD1;\n    background: rgba(30, 32, 61, 1);\n\n}\n\n\n.icon-ria {\n    width: 18px;\n    margin-left: 70%;\n}\n\n.icon-ria-delete {\n    width: 15px;\n    margin-left: 10px;\n}\n\n.stackcol-ria {\n    margin-top: 10px;\n    border-radius: 12px;\n    height: 80vh;\n    /* background: linear-gradient(180deg, #303245, #0C1020), linear-gradient(180deg, #424750, #202326); */\n    background: transparent;\n}\n\n.gradient-ria2 {\n    /* background: linear-gradient(180deg, #FFFFFF 0%, #E0E2FF 93.5%);\n    opacity: 0.15; */\n\n}\n\n.container-upload-ria {\n    border: 1px solid #6B5CD1;\n    border-radius: 10px;\n    padding-top: 10px;\n    margin-top: 10px;\n    height: 80vh;\n    width: 70vw;\n    background: rgba(255, 255, 255, 0.1);\n}\n\n.browse-files-containers-ria {\n    border: 1px solid grey;\n    background-color: transparent;\n    margin-right: 25px;\n    color: white;\n    text-align: center;\n    height: 135px;\n    width: 45%;\n    border-radius: 10px;\n}\n\n.right-sub-container-ria {\n    border: 1px solid rgba(0, 0, 0, 0.1);\n    border-radius: 10px;\n    padding-top: 10px;\n    justify-content: center;\n    text-align: center;\n    color: #1D203C;\n    font-family: 'Graphik', sans-serif;\n    /* background-color: rgba(0, 0, 0, 0.1); */\n    background: linear-gradient(180deg, #11121E 0%, #16182E 100%), linear-gradient(180deg, #424750 0%, #202326 100%);\n    margin-top: 8%;\n}\n\n.right-sub-container-ria-diplay {\n    height: 230px;\n    width: 80%;\n    margin-left: 10%;\n}\n\n.right-metadata-container-ria-diplay {\n    margin-left: 10%;\n    height: 230px;\n    width: 100%;\n}\n\n/* .upload-ria-button {\n    margin-top: 5%;\n    margin-left: 45%;\n    background-color: #6B5CD1;\n    border-radius: 10px;\n    border: none;\n} */\n\n/* .process-ria-button {\n    margin-top: 40%;\n    margin-left: 43%;\n    background-color: #6B5CD1;\n    border-radius: 10px;\n    border: none;\n} */\n.process-ria-button {\n    margin-top: 45%;\n    margin-left: 45%;\n    background: linear-gradient(131.99deg, #0AAAE0 6.23%, rgba(10, 170, 224, 0.5) 85.46%);\n    border-radius: 50px;\n    color: #FFFFFF;\n    font-size: 13px;\n    font-weight: 400;\n    border: none;\n}\n\n.metadata-ria {\n    position: absolute;\n    display: flex;\n    border: 1px solid;\n    /* background: rgba(255, 255, 255, 0.1); */\n    /* border: 1px solid #6B5CD1; */\n\n    border-image-source: linear-gradient(180deg, #424750 0%, #202326 100%);\n    /* background: rgba(42, 45, 78, 1); */\n    /* background: linear-gradient(180deg, #11121E 0%, #16182E 100%),\n        linear-gradient(180deg, #424750 0%, #202326 100%); */\n    background: linear-gradient(180deg, #11121E 0%, #16182E 100%), linear-gradient(180deg, #424750 0%, #202326 100%);\n    top: 2%;\n    border-radius: 10px;\n    width: 97%;\n    left: 3%;\n    padding-bottom: 10px;\n}\n\n.metdata-container-ria {\n    position: absolute;\n    /* background: rgba(60, 64, 105, 1); */\n    background: rgba(255, 255, 255, 0.1);\n    /* background: linear-gradient(180deg, #FFFFFF 0%, #E0E2FF 93.5%); */\n    top: 3%;\n    border-radius: 10px;\n    height: 80vh;\n    width: 70vw;\n    overflow-y: auto;\n    border: 1px solid #6B5CD1;\n}\n\n.metdata-accordian-ria {\n    position: absolute;\n    margin-top: 33%;\n    border-radius: 10px;\n    width: 97%;\n    background-color: rgba(60, 64, 105, 1);\n    border: none;\n    color: white\n}\n\n.metdata-accordian-ria .accordion-body {\n    background-color: #1E203D;\n    color: white;\n    overflow-y: scroll;\n    max-height: 360px;\n    border: none;\n}\n\n.accordion-item {\n    border: none;\n}\n\n.accordion-button.collapsed {\n    background: blue\n}\n\n.panel-heading a:not(.collapsed) {\n    border-bottom: 1px solid red;\n}\n\n.accordion-button.collapsed::after {\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e\");\n}\n\n/* .accordion-button.collapsed::before {\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e\");\n  } */\n\n.accordion-button:not(.collapsed)::after {\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e\");\n}\n\n.priority-ria {\n    background: linear-gradient(96.44deg, #8E2DE2 10.7%, #6A19D8 89.51%);\n    border: none;\n    font-size: 10px;\n    font-weight: 400;\n    font-family: Graphik;\n    border-radius: 20px;\n    height: 25px;\n    margin-left: 10px;\n    margin-bottom: 10px;\n}\n\n.image-ria-bg {\n    background: rgba(0, 0, 0, 0.1);\n    border-radius: 10px;\n}\n\n.browse-text-ria {\n    margin-top: 5px;\n    text-align: center;\n}\n\n/* .upload-file-button-ria {\n    font-size: 10px;\n    font-size: 14px;\n    font-family: Graphik;\n    width: 70%;\n    height: 35px;\n    margin-top: 25px;\n    margin-left: 20px;\n    margin-right: 20px;\n    color: #fff;\n    border-radius: 50px;\n    background-color: #6B5CD1;\n    cursor: pointer;\n} */\n\n.final-stack-ria {\n    position: relative;\n}\n\n.upload-ria {\n    position: absolute;\n    width: 20px;\n    top: 5%;\n    left: 93%;\n    cursor: pointer;\n}\n\n/* .resizable {\n    border: 1px solid #ccc;\n    padding: 10px;\n    overflow: hidden; \n    resize: both; \n  }\n  .left-sub-container-ref {  \n    min-width: 25%;\n    color: #FFFFFF;\n    font-family: 'Graphik', sans-serif;\n    margin-right: 10px;\n    padding: 10px;\n    text-align: center;\n    align-self: normal;\n    border: 1px solid rgba(255, 255, 255, 0.3);\n    border-radius: 10px;\n    resize: horizontal;\n    cursor: ew-resize;\n    background: linear-gradient(180deg, #303245 0%, #0C1020 100%);\n\n\n    \n  }\n  .right-sub-container-ref {\n    flex-grow: 1;\n    border: 1px solid rgba(0, 0, 0, 0.1);\n    border-radius: 10px;\n    padding-top: 10px;\n    justify-content: center;\n    text-align: center;\n    height: 230px;\n    max-width: 70%;\n    color: #1D203C;\n    font-family: 'Graphik', sans-serif;\n    resize: both;\n    margin-left: 10px;\n    background:  linear-gradient(to bottom,rgba(255, 255, 255, 0.15),rgba(224, 226, 255, 1)); \n\n  } */\n.ria-file-upload {\n    display: inline-block;\n    position: relative;\n    font-family: Arial, sans-serif;\n    /* overflow: hidden; */\n    margin-right: 5px;\n    margin-top: 5px;\n    /* margin-left: 78%; */\n    padding-bottom: 5px;\n}\n\n.ria-file-upload input[type=\"file\"] {\n    font-size: 0px;\n    position: absolute;\n    left: 0;\n    top: 0;\n    opacity: 0;\n}\n\n.ria-file-upload-span {\n    padding: 5px 6px 8px 0px;\n    cursor: pointer;\n    border-radius: 5px;\n    border: 1px solid rgba(116, 123, 169, 1);\n    color: rgba(255, 255, 255, 1);\n}\n\n.ria-file-upload-span:hover {\n    background: rgba(116, 123, 169, 1);\n}\n\n.ria-file-upload-load {\n    padding: 6px 6px 5px 6px;\n    border-radius: 5px;\n    border: 1px solid rgba(116, 123, 169, 1);\n    color: rgba(255, 255, 255, 1);\n    /* width:100px; */\n    /* height:20px; */\n    /* margin-left: 60px; */\n    /* background-color: rgba(116, 123, 169, 0.3); */\n}\n\n.position-nav-ria {}\n\n\n\n.modal-overlay-ria {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    position: fixed;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(0, 0, 0, 0.5);\n    z-index: 1000;\n    top: 0;\n    left: 0;\n}\n\n.modal-ria {\n    background-color: rgba(30, 32, 61, 1);\n    border: 1px solid #6B5CD1;\n    border-radius: 8px;\n}\n\n.modal-content-ria {\n    /* display: flex; */\n    margin-left: 5px;\n    /* flex-direction: row; */\n    margin-right: 10px;\n    padding: 20px 0px;\n}\n\n.close-icon-ria {\n    font-size: 24px;\n    position: absolute;\n    cursor: pointer;\n    color: blueviolet;\n    background-color: transparent;\n    border: none;\n    border-radius: 5px;\n    width: 23px;\n    float: left;\n    margin-left: 170px;\n}\n\n.final-button-ria {\n    border: 1px solid #6A59FF;\n    border-radius: 10px;\n    background-color: transparent;\n    font-size: 13px;\n    font-family: Graphik;\n    color: #FFFFFF;\n    font-weight: 300;\n    padding: 5px 10px;\n    margin: 0px 10px 20px 12px;\n    width: 13vw;\n    max-height: 5vh;\n}\n\n.final-button-ria:hover {\n    background-color: linear-gradient(131.99deg, #0AAAE0 6.23%, #0AAAE0 85.46%);\n\n}\n\n.nav-button-ria:hover {\n    background: linear-gradient(131.99deg, #0AAAE0 6.23%, #0AAAE0 85.46%);\n    /* background-color:  #0AAAE0; */\n    color: #FFFFFF;\n    /* color: black; */\n}\n\n.shade-ria {\n    display: flex;\n    flex-direction: row;\n    /* background-color: #6a59ff28; */\n    width: 30vw;\n    height: 10vh;\n}\n\n.key-table-ria {\n    color: white !important;\n    font-size: 12px !important;\n    font-family: Graphik !important;\n    font-weight: 400 !important;\n    margin-top: 5px !important;\n    line-height: 35px !important;\n}\n\n.para-first-ref {\n    color: #FFFFFF;\n    background-color: transparent;\n    text-align: center;\n    font-weight: 400;\n    margin-top: 10px;\n}\n\n.loader-screen-ref {\n    background: transparent;\n    padding: 35px;\n    min-width: 100%;\n    border: 1px solid #6B5CD1;\n    border-radius: 10px;\n    margin: 10px;\n    height: 80vh;\n    width: 70vw;\n}\n\n.loader-ref {\n    margin-top: 85px;\n    margin-left: 32vw;\n}\n\n\n.loader-ref-sidebar {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 40px;\n    margin-top: 90px;\n    margin-right: 90px;\n    margin-left: 60px;\n}\n\n.loader-ref-modal {\n    margin-top: 20px;\n    margin-left: 12vw;\n    width: 22vw;\n    height: 1px;\n}\n\n.para-first-ref2 {\n    color: #FFFFFF;\n    background-color: transparent;\n    text-align: center;\n    font-weight: 400;\n    margin-top: 10px;\n}\n\n.loader-screen-ref2 {\n    background: transparent;\n    padding: 35px;\n    min-width: 91vw;\n    border: 1px solid #6B5CD1;\n    border-radius: 10px;\n    /* margin-top: 20px; */\n    margin-left: 15px;\n    margin-right: 30px;\n    height: 76vh\n}\n\n.loader-ref2 {\n    margin-top: 80px;\n    margin-left: 47%;\n}\n\n.table-ria {\n    color: white;\n    font-size: 12px;\n    font-family: Graphik;\n    font-weight: 400;\n    margin-top: 10px;\n    margin-left: 6px;\n    line-height: 35px;\n    margin-bottom: 10px;\n}\n\n.chatbot-img-full-ria {\n    width: 100%;\n    border-radius: 5px;\n    height: 100%;\n    padding: 7px;\n    border: 1px solid #FFFFFF;\n    /* margin: 30px 60px; */\n}\n\n.modal-ria-img {\n    background-color: rgba(30, 32, 61, 1);\n    border: 1px solid #6B5CD1;\n    border-radius: 8px;\n    overflow-y: auto;\n    height: 60%;\n    width: 50%;\n    text-align: center;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.image-choosen {\n    width: 150px;\n    margin: 15px 10px;\n    border: none;\n    border-radius: 10px;\n}\n\n.gallery-text {\n    font-family: Graphik;\n    font-size: 13px;\n    font-weight: 400;\n    color: white;\n    margin: 10px;\n}\n\n.accordian-test-ria {\n    font-family: Graphik;\n    font-size: 12px;\n    color: black;\n}\n\n/* \n.accordion-button {\n    width: 100%;\n    background-color: white;\n    max-height: 40px;\n    color: black;\n  } */\n.accordion-button:not(.collapsed) {\n    background-color: rgba(21, 23, 43, 1);\n    color: #FFFFFF;\n    font-family: Graphik;\n    font-size: 14px;\n}\n\n.accordion-button.collapsed {\n    background-color: rgba(21, 23, 43, 1);\n    color: #FFFFFF;\n    font-family: Graphik;\n    font-size: 14px;\n}\n\n\n\n.item-equip-ria {\n    margin-bottom: auto;\n    text-align: left;\n    font-size: 12.5px;\n    margin-left: 10px;\n    font-weight: 500;\n}\n\n.item-timestamp-ria {\n    margin-bottom: auto;\n    font-size: 12px;\n    font-weight: 400;\n    margin-left: 10px;\n    margin-top: 5px;\n}\n\n.upload-image {\n    font-size: 16px;\n    font-weight: 500;\n    text-align: center;\n    margin-bottom: 15px;\n}\n\n.key-table-ria {\n    color: white;\n}\n\n.uploaded-num-ria {\n    margin-left: 450px;\n    font-weight: 300;\n    font-size: 12px;\n}\n\n.add-info-ria {\n    font-size: 15px;\n    font-weight: 500;\n}\n\n.nav-button-ria {\n    background: transparent;\n    border: 1px solid #0AAAE0;\n    /* border-image-source: linear-gradient(180deg, #0AAAE0 0%, #0AAAE0 100%); */\n    width: 100px;\n    border-radius: 50px;\n    color: #0AAAE0;\n    margin-left: 5px;\n    font-size: 14px;\n    font-family: Graphik;\n    font-weight: 400;\n    padding: 3px;\n}\n\n/* .nav-button-ria {\n    border: 1px solid #6A59FF;\n    border-radius: 10px;\n    background-color: transparent;\n    font-size: 13px;\n    font-family: Graphik;\n    color: #FFFFFF;\n    font-weight: 300;\n    padding: 5px 15px;\n    margin-left: 40px;\n} */\n\n\n.arrow-pic-ria {\n    width: 10px;\n    margin-top: -2px;\n    margin-left: 2px;\n    margin-right: 2px;\n    /* color:#0AAAE0; */\n}\n\n.nav-button-container1-ria {\n    text-align: right;\n}\n\n.upload-file-button-ria {\n    font-size: 10px;\n    font-size: 14px;\n    font-family: Graphik;\n    width: 70%;\n    height: 35px;\n    margin-top: 25px;\n    margin-left: 20px;\n    margin-right: 20px;\n    color: #fff;\n    border: 2px solid #297FAE;\n    /* border: 1px solid;\n    border-image-source: linear-gradient(180deg, #0EA3D7 0%, #297FAE 100%); */\n    border-radius: 50px;\n    /* background-color: #6B5CD1; */\n    cursor: pointer;\n}\n\n.upload-ria-button {\n    margin-top: 5%;\n    margin-left: 42%;\n    /* background-color: #6B5CD1; */\n    background: linear-gradient(131.99deg, #0AAAE0 6.23%, rgba(10, 170, 224, 0.5) 85.46%);\n    border-radius: 50px;\n    border: none;\n    color: #FFFFFF;\n    font-size: 13px;\n    font-weight: 400;\n    width: 150px;\n    height: 30px;\n}\n\n.regenerate-ria {\n    width: 23px;\n    margin-left: 10px;\n    /* margin-bottom: 3px; */\n    cursor: pointer;\n    border: 1px solid #6A19D8;\n    padding: 2px;\n    border-radius: 5px;\n    margin-bottom: 10px;\n}\n\n.row1-ria {\n    background: linear-gradient(180deg, #11121E 0%, #16182E 100%), linear-gradient(180deg, #424750 0%, #202326 100%);\n    /* margin-left: -10px; */\n    width: 106%;\n    border-radius: 10px;\n    --bs-gutter-x: 1.5rem;\n    --bs-gutter-y: 0;\n    display: flex;\n    flex-wrap: wrap;\n    margin-top: calc(-1 * var(--bs-gutter-y));\n    margin-right: calc(-0.5 * var(--bs-gutter-x));\n    margin-left: calc(-0.5 * var(--bs-gutter-x));\n    border: 1px solid #6A19D8;\n}\n\n.row1-ria1 {\n    width: 100%;\n    border-radius: 10px;\n    --bs-gutter-x: 1.5rem;\n    --bs-gutter-y: 0;\n    display: flex;\n    flex-wrap: wrap;\n    margin-top: calc(-1 * var(--bs-gutter-y));\n    margin-right: calc(-0.5 * var(--bs-gutter-x));\n    margin-left: calc(-0.5 * var(--bs-gutter-x));\n}\n\n.top-part-chart-chatbot-ria {\n    height: 40px;\n    width: 100%;\n    border-top-left-radius: 10px;\n    border-top-right-radius: 10px;\n    display: flex;\n    flex-direction: row;\n    border-bottom: 1px solid #6B5CD1;\n    /* background-color: rgb(54, 54, 89); */\n    padding: 5px;\n    color: white;\n    font-size: 13px;\n    font-weight: 500;\n    /* background: linear-gradient(180deg, #11121E 0%, #16182E 100%),\nlinear-gradient(180deg, #424750 0%, #202326 100%); */\n    background: rgba(26, 28, 53, 1);\n\n}\n\n.bottom-part-chart-chatbot-ria {\n    margin-top: 10px;\n    display: flex;\n    width: 100%;\n    background: rgba(26, 28, 53, 1);\n    /* background-color: rgb(54, 54, 89); */\n    border-bottom-left-radius: 10px;\n    border-bottom-right-radius: 10px;\n    border: 1px solid #6B5CD1;\n}\n\n.left-section-chat-chatbot-ria {\n    /* background: linear-gradient(180deg, #303245 0%, #0C1020 100%), linear-gradient(180deg, #424750 0%, #202326 100%); */\n    background-color: #1E203D;\n    /* background: linear-gradient(0deg, #2A2D4E, #2A2D4E),\n    linear-gradient(0deg, #747BA9, #747BA9); */\n    /* background: linear-gradient(180deg, #FFFFFF 0%, #E0E2FF 93.5%); */\n\n    border: 1px solid #6B5CD1;\n    border-radius: 10px;\n    display: flex;\n    flex-direction: column;\n    /* height: 85vh; */\n    /* width: 37vw; */\n}\n\n.bg-bot-chatbot-ria {\n    /* background-color: rgba(45, 50, 90, 1); */\n    border-radius: 0px 10px 10px 10px;\n    background: linear-gradient(180deg, #11121E 0%, #16182E 100%),\n        linear-gradient(180deg, #424750 0%, #202326 100%);\n}\n\n\n.chat-input-chart-chatbot-ria ::placeholder {\n    color: white;\n    font-family: Graphik;\n    font-size: 14px;\n    font-weight: 350;\n}\n\n.chat-input-chart-chatbot-ria:focus {\n    border: 1px solid black;\n}\n\n.chat-input-chart-chatbot-ria {\n    margin-left: 3%;\n    margin-right: 10px;\n    /* margin-top: 10px; */\n    padding: 2px;\n    width: 90%;\n    font-family: 'Graphik', sans-serif;\n    color: white;\n    font-size: 14px;\n    height: 15%;\n    background: rgba(26, 28, 53, 1);\n    /* background: linear-gradient(180deg, #11121E 0%, #16182E 100%),\n    linear-gradient(180deg, #424750 0%, #202326 100%);; */\n}\n\n.bg-user-chatbot-ria {\n    background-color: rgba(26, 28, 53, 1);\n    border-radius: 0px 10px 10px 10px;\n    border-style: icon solid;\n    min-width: 50px;\n    margin-left: 40px;\n}\n\n\n\n\n::-webkit-scrollbar-track {\n    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\n    border-radius: 10px;\n    background-color: transparent;\n    width: 2px;\n}\n\n::-webkit-scrollbar {\n    width: 4px;\n    height: 4px;\n    background-color: transparent;\n}\n\n\n::-webkit-scrollbar-thumb {\n    border-radius: 10px;\n    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, .3);\n    background-color: #F5F5F5;\n}\n\n\n.InputGroup-ria1 .form-control {\n    background-color: #1A1C35;\n    color: #FFFFFF;\n    border: 1px solid #747BA9;\n    font-size: 12px;\n    height: 90px;\n}\n\n.text-chart-chatbot-ria {\n    margin-top: 5px;\n    color: white;\n    /* background-color: rgba(37, 40, 67, 1); */\n    font-size: 12px;\n    font-weight: 400;\n    margin-right: 5px;\n    font-family: Graphik;\n    padding-left: 7px;\n    height: 80px;\n    width: 100%;\n    border-radius: 10px;\n    border: 1px solid #6B5CD1;\n    background-color: #1A1C35;\n    text-align: left;\n}\n\n.chat-messages-c-chatbot-ria {\n    height: 63vh;\n    color: white;\n    font-size: 10px;\n    overflow-y: scroll;\n}\n\n.analysis-head2-file-ria {\n    color: #FFFFFF;\n    font-size: 13px;\n    font-family: Graphik;\n    font-weight: 450;\n    margin-top: 10px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
